import { useWeb3React } from '@web3-react/core'
import { ethers } from 'ethers'
import { useEffect, useState } from 'react'
import { injected } from '../connectors'
import { Addresses, TokenAddresses, NETWORKS, TOKENS } from '../addresses'

export function useAddresses() {
  const { library, activate } = useWeb3React<ethers.providers.Web3Provider>()

  // TODO: initial value
  const [addresses, setAddresses] = useState<Addresses>(
    NETWORKS[library?.network?.chainId || 1]
  )

  useEffect(() => {
    const handleNetworkChanged = (network: ethers.providers.Network) => {
      setAddresses(NETWORKS[network.chainId])
      activate(injected, undefined, true).catch(error => {
        console.error('Failed to activate after chain changed', error)
      })
    }

    library?.on('network', handleNetworkChanged)
    return () => {
      library?.off('network', handleNetworkChanged)
    }
  }, [library?.network, activate, library])

  return addresses || {}
}

export function useTokenAddresses() {
  const { library, activate } = useWeb3React<ethers.providers.Web3Provider>()

  // TODO: initial value
  const [addresses, setAddresses] = useState<TokenAddresses>(
    TOKENS[library?.network?.chainId || 1]
  )

  useEffect(() => {
    const handleNetworkChanged = (network: ethers.providers.Network) => {
      setAddresses(TOKENS[network.chainId])
      activate(injected, undefined, true).catch(error => {
        console.error('Failed to activate after chain changed', error)
      })
    }

    library?.on('network', handleNetworkChanged)
    return () => {
      library?.off('network', handleNetworkChanged)
    }
  }, [library?.network, activate, library])

  return addresses || {}
}
